import React from 'react';

import {
  Actions as UIActions,
  Action,
  FileCopyIcon,
  EditIcon,
  HighlightOffIcon,
} from '@gogame/components';

import {
  ACTION_DUPLICATE,
  ACTION_EDIT,
  ACTION_DELETE,
} from 'scenes/KPI/constants';

export const KPIActions = ({
  onDuplicate,
  onEdit,
  onDelete,
  data,
  visibleSeries,
}) => {
  const { id } = data;
  const current = visibleSeries.find((s) => s.id === id);
  const first = visibleSeries[0];
  const isFirst = first.id === id;

  const handleEdit = (e) => {
    onEdit(e, {
      current,
      isFirst,
      first,
    });
  };

  const handleDuplicate = (e) => {
    onDuplicate(e, {
      current,
      isFirst,
      first,
    });
  };

  return (
    <UIActions>
      <Action
        id={ACTION_DUPLICATE}
        label={'Duplicate'}
        icon={<FileCopyIcon />}
        onClick={handleDuplicate}
      />
      <Action
        id={ACTION_EDIT}
        label={'Edit'}
        icon={<EditIcon />}
        onClick={handleEdit}
      />
      <Action
        id={ACTION_DELETE}
        label={'Delete'}
        icon={<HighlightOffIcon />}
        onClick={(e) => onDelete(e, data, visibleSeries)}
      />
    </UIActions>
  );
};

export default KPIActions;
